/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  UpdateTradingChallengeOptions,
  UpdateTradingChallengeResponses,
} from '../types/UpdateTradingChallenge'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Partially update a trading challenge: a field that is absent from the body is left unchanged. Which fields may be updated depends on the challenge status. PENDING accepts every field. ACTIVE accepts only name, max_users, end and the three prize quantities, because participants are already funded and being measured. COMPLETED accepts none. A request that touches a field the current status does not allow is rejected as a whole with 409. ADMIN may update any challenge, INTEGRATOR only challenges of its own tenant, and COMPETITION_MANAGER only assigned challenge IDs.
 * @summary Update a trading challenge
 * {@link /v1/trading_challenges/:trading_challenge_id}
 */
export function updateTradingChallenge<ThrowOnError extends boolean = true>(
  options: Options<UpdateTradingChallengeOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateTradingChallengeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/trading_challenges/{trading_challenge_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateTradingChallengeResponses, ThrowOnError>>,
  )
}
